import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CalendarBlank, Flag, SealCheck, Clock, Warning, Archive } from "@phosphor-icons/react";

const STATUS_PILL = {
  accepted: { cls: "bg-[#1E5631]/10 text-[#1E5631]", icon: <SealCheck size={11} weight="fill" />, label: "Attested" },
  pending:  { cls: "bg-[#FFC72C]/15 text-[#0F2537]", icon: <Clock size={11} weight="fill" />, label: "Pending" },
  rejected: { cls: "bg-red-100 text-red-700", icon: <Warning size={11} weight="fill" />, label: "Rejected" },
  legacy:   { cls: "bg-[#0F2537]/10 text-[#0F2537]/70", icon: <Archive size={11} weight="fill" />, label: "Legacy" },
};

export default function Rounds() {
  const [rounds, setRounds] = useState([]);
  useEffect(() => { api.get("/rounds").then((r) => setRounds(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div className="rise">
        <span className="label-eyebrow">My rounds</span>
        <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tighter mt-1">Every card.</h1>
        <p className="text-[#0F2537]/70 mt-2">All your recorded rounds, newest first.</p>
      </div>

      {rounds.length === 0 ? (
        <div className="card-default p-10 text-center">
          <Flag size={32} weight="duotone" className="mx-auto text-[#E05D3A]" />
          <p className="mt-3 text-[#0F2537]/70">No rounds yet.</p>
          <Link to="/rounds/new" data-testid="empty-state-new-round" className="mt-4 inline-block px-4 py-2 rounded-xl bg-[#E05D3A] text-white font-bold">Record one</Link>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {rounds.map((r, i) => {
            const pill = STATUS_PILL[r.attester_status];
            return (
              <Link to={`/rounds/${r.id}`} key={r.id} className="card-interactive p-5 rise" style={{ animationDelay: `${i * 50}ms` }} data-testid={`round-card-${r.id}`}>
                <div className="flex items-start justify-between">
                  <div>
                    <div className="text-xs label-eyebrow flex items-center gap-1"><CalendarBlank size={12} weight="fill" /> {new Date(r.played_at).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" })}</div>
                    <h3 className="font-heading font-bold text-lg mt-1">{r.course_name}</h3>
                    <div className="text-xs text-[#0F2537]/70 mt-1">{r.tees} tees · CR {r.course_rating} · Slope {r.slope_rating}</div>
                    {pill && (
                      <span className={`mt-2 inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-full ${pill.cls}`} data-testid={`round-pill-${r.id}`}>
                        {pill.icon} {pill.label}
                      </span>
                    )}
                  </div>
                  <div className="text-right">
                    <div className="font-heading font-black text-3xl">{r.total_strokes}</div>
                    <div className="text-xs font-semibold" style={{ color: r.total_strokes <= r.total_par ? "#1E5631" : "#E05D3A" }}>
                      {r.total_strokes - r.total_par >= 0 ? "+" : ""}{r.total_strokes - r.total_par} vs par
                    </div>
                  </div>
                </div>
                <div className="mt-3 text-xs text-[#0F2537]/70">Differential <b className="text-[#0F2537]">{r.differential > 0 ? "+" : ""}{r.differential}</b></div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
